export const dateRange = {
  fromDate: {
    en: 'From date',
    nb: 'Fra dato',
    nn: 'Frå dato',
  },
  toDate: {
    en: 'To date',
    nb: 'Til dato',
    nn: 'Til dato',
  },
  invalidDateFormat: {
    en: 'Use YYYY-MM-DD (ISO 8601) format.',
    nb: 'Bruk formatet ÅÅÅÅ-MM-DD (ISO 8601).',
    nn: 'Bruk formatet ÅÅÅÅ-MM-DD (ISO 8601).',
  },
  fromAfterTo: {
    en: 'Start date cannot be after end date.',
    nb: 'Fra-dato kan ikke være etter til-dato.',
    nn: 'Frå-dato kan ikkje vere etter til-dato.',
  },
} as const;
